var _defs, _polyline, _polyline2, _polyline3, _polyline4, _polyline5, _polyline6, _polyline7, _polyline8, _polyline9, _polyline10, _polyline11, _polyline12, _polyline13, _polyline14, _polyline15, _polyline16, _polyline17, _polyline18, _polyline19, _polyline20, _polyline21, _polyline22, _polyline23, _polyline24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1c1e53;}"))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "22.14 17.5 26.79 22.14 22.14 26.79 17.5 22.14 22.14 17.5"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "31.43 17.5 36.07 22.14 31.43 26.79 26.79 22.14 31.43 17.5"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "40.54 17.5 45 21.25 40.54 25 36.07 21.25 40.54 17.5"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "50 17.5 54.64 22.14 50 26.79 45.36 22.14 50 17.5"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "59.29 17.5 63.93 22.14 59.29 26.79 54.64 22.14 59.29 17.5"
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "68.57 17.5 73.21 22.14 68.57 26.79 63.93 22.14 68.57 17.5"
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "77.86 17.5 82.5 22.14 77.86 26.79 73.21 22.14 77.86 17.5"
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "22.14 26.79 26.79 31.43 22.14 36.07 17.5 31.43 22.14 26.79"
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "77.86 26.79 82.5 31.43 77.86 36.07 73.21 31.43 77.86 26.79"
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "22.14 36.07 26.79 40.71 22.14 45.36 17.5 40.71 22.14 36.07"
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "77.86 36.07 82.5 40.71 77.86 45.36 73.21 40.71 77.86 36.07"
  })), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "22.14 45.36 26.79 50 22.14 54.64 17.5 50 22.14 45.36"
  })), _polyline13 || (_polyline13 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "77.86 45.36 82.5 50 77.86 54.64 73.21 50 77.86 45.36"
  })), _polyline14 || (_polyline14 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "22.14 54.64 26.79 59.29 22.14 63.93 17.5 59.29 22.14 54.64"
  })), _polyline15 || (_polyline15 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "77.86 54.64 82.5 59.29 77.86 63.93 73.21 59.29 77.86 54.64"
  })), _polyline16 || (_polyline16 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "22.14 63.93 26.79 68.57 22.14 73.21 17.5 68.57 22.14 63.93"
  })), _polyline17 || (_polyline17 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "77.86 63.93 82.5 68.57 77.86 73.21 73.21 68.57 77.86 63.93"
  })), _polyline18 || (_polyline18 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "22.14 73.21 26.79 77.86 22.14 82.5 17.5 77.86 22.14 73.21"
  })), _polyline19 || (_polyline19 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "31.43 73.21 36.07 77.86 31.43 82.5 26.79 77.86 31.43 73.21"
  })), _polyline20 || (_polyline20 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "40.71 73.21 45.36 77.86 40.71 82.5 36.07 77.86 40.71 73.21"
  })), _polyline21 || (_polyline21 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "50 73.21 54.64 77.86 50 82.5 45.36 77.86 50 73.21"
  })), _polyline22 || (_polyline22 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "59.29 73.21 63.93 77.86 59.29 82.5 54.64 77.86 59.29 73.21"
  })), _polyline23 || (_polyline23 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "68.57 73.21 73.21 77.86 68.57 82.5 63.93 77.86 68.57 73.21"
  })), _polyline24 || (_polyline24 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "77.86 73.21 82.5 77.86 77.86 82.5 73.21 77.86 77.86 73.21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg12);
export default __webpack_public_path__ + "static/media/12.24ad0e6c57c937051d6de7ee157ca0d8.svg";
export { ForwardRef as ReactComponent };